import { useEffect } from 'react';

/** Sets "<title> - QckOrder". The pending-order prefix is added by usePendingOrders. */
export const usePageTitle = (title: string): void => {
    useEffect(() => {
        document.title = `${title} — QckOrder`;
    }, [title]);
};
